import { render } from "./ContactForm.vue?vue&type=template&id=9fbc71a4"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
script.render = render

export default script